import { render, staticRenderFns } from "./AppDesktopNavigation.vue?vue&type=template&id=63d8cb91&"
import script from "./AppDesktopNavigation.vue?vue&type=script&lang=js&"
export * from "./AppDesktopNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppDesktopNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports